import React, { useState } from 'react';
import classNames from 'classnames';
import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import GetAppIcon from '@mui/icons-material/GetApp';
import FileIcon from '../File/FileIcon';
import ThemableButton from '../../theme/components/Button/ThemableButton';
import { getExtension, getFilename } from '../../lib/File';

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    justifyContent: 'flex-start',
  },
  label: {
    ...theme.typography.body2,
    textTransform: 'none',
  },
  name: {
    overflow: 'hidden',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

interface Props {
  filename: string;
  mime: string;
  url: string;
}

const MessageAttachment: React.FC<Props> = (props: Props) => {
  const { filename, mime, url } = props;

  const classes = useStyles();

  const [hover, setHover] = useState(false);

  const name = getFilename(filename);
  const extension = getExtension(filename);

  return (
    <ThemableButton
      classes={{ root: classes.button }}
      endIcon={hover && <GetAppIcon color="secondary" />}
      fullWidth
      href={url}
      target="_blank"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      size="large"
      startIcon={<FileIcon mimeType={mime} />}
    >
      <span className={classNames(classes.label, classes.name)}>{name}</span>
      <span className={classNames(classes.label)}>.{extension}</span>
      <span style={{ flex: 1 }} />
    </ThemableButton>
  );
};

export default MessageAttachment;
